import { Component, OnInit } from "@angular/core";
import { AuthService } from "src/services/auth.service";
import { SharedService } from "src/services/shared.service";
import { TouDocument } from 'src/app/models/touDocument-model';

@Component({
    selector:'app-support',
    templateUrl:'./support.component.html',
    styleUrls:['./support.component.scss']
})

export class Support implements OnInit {
    email:string
    TouDocument: TouDocument = new TouDocument();
    constructor(private sharedService: SharedService, public authService: AuthService){}
    ngOnInit(): void {
        this.sharedService.getCodeList('TargetMarket'), this.sharedService.getSupportLink().subscribe((response: Array<any>) => {
            var currentMO = response.find(c => c.moid === this.authService.currentCRMUser.MOID);
            this.email = currentMO?.email || 'helpdesk@gs1.org'    
          }, err => { console.log(err); });

    }
    clickSupportLink() {
        this.sharedService.getCodeList('TargetMarket'), this.sharedService.getSupportLink().subscribe((response: Array<any>) => {
          var currentMO = response.find(c => c.moid === this.authService.currentCRMUser.MOID);
          window.open(currentMO.link, '_blank');
    
        }, err => { console.log(err); });
    }
    
    clickSupportGuide() {        
        const selectedLang =  localStorage.getItem("preferedLanguageCode") || 'en';
        this.sharedService.getUserGuide(selectedLang).subscribe(response => {
            this.TouDocument = response as TouDocument;
            const arrayBuffer = this.sharedService.base64ToArrayBuffer(this.TouDocument.FileBytes);
            this.sharedService.createAndDownloadBlobFile(arrayBuffer, this.TouDocument.FileName, 'null', this.TouDocument.ContentType);
          }, err=>{
            console.log('Error in loading user guide. Error: '+err);            
          });
          
    }
}